import { coreApi, payableApi } from "../client";
import { EMPLOYEE } from "../endpoints";

export const getFilteredEmpDetails = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.FILTER, payload);
  return res.data;
};

export const saveEmployee = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.SAVE, payload);
  return res.data;
};

export const updateEmployee = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.UPDATE, payload);
  return res.data;
};

export const getEmployeeById = async (id) => {
  const res = await coreApi.post(`${EMPLOYEE.GET_BY_ID}?empId=${id}`, {});
  return res.data;
};

export const deleteEmployee = async (employeeId) => {
  const res = await coreApi.post(`${EMPLOYEE.DELETE}?empId=${employeeId}`);
  return res.data;
};

export const getPayrollDetails = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.PAYROLL_DETAILS, payload);
  return res.data;
};

export const getRelationList = async () => {
  const res = await coreApi.get(EMPLOYEE.RELATION_LIST);
  return (res.data || []).map((item) => ({
    label: item.Name || item.name,
    value: item.RelationId || item.id,
    refCode: item.referenceCode,
    refId: item.referenceID
  }));
};

export const addRelation = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.ADD_RELATION, payload);
  return res.data;
};

export const getBankList = async () => {
  const res = await coreApi.get(EMPLOYEE.BANK_LIST);
  return (res.data || []).map((item) => ({
    label: item.BankName,
    value: item.ID,
  }));
};

export const addBank = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.ADD_BANK, payload);
  return res.data;
};

export const getEmployeeAudit = async (empId) => {
  const res = await coreApi.get(EMPLOYEE.AUDIT, { params: { empId } });
  return res.data;
};

export const importEmployees = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.IMPORT, payload);
  return res.data;
};

export const EmployeeQuickAdd = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.QUICK_ADD, payload);
  return res.data;
};

export const getEmpName = async (corpId, frequencyID) => {
  const res = await coreApi.post(`${EMPLOYEE.GET_NAMES}?corpID=${corpId}&FreqID=${frequencyID}`);
  return res.data || [];
};

export const getFrequencies = async () => {
  const res = await coreApi.get(EMPLOYEE.FREQUENCIES);
  const allowed = ["Weekly","Biweekly","Monthly","Quarterly","Semimonthly","Annually"];
  return (res.data?.ListInfo || [])
    .filter((i) => allowed.includes(i.Name))
    .map((i) => ({ label: i.Name, value: i.ID }));
};

export const getProfitCenters = async (corpId) => {
  const res = await coreApi.get(EMPLOYEE.PROFIT_CENTERS, {
    params: { CorpID: corpId },
  });

  const rawData =
    res?.data?.ListInfo ??
    res?.data?.ProfitCenters ??
    res?.data ??
    [];

  const safeData = Array.isArray(rawData) ? rawData : [];

  return safeData.map((pc) => ({
    label: pc.Name || pc.ProfitCenterName,
    value: pc.ID || pc.ProfitCenterId,
    corporationName: pc.CorporationName,
  }));
};

export const getCountries = async () => {
  const res = await payableApi.get(EMPLOYEE.COUNTRIES);
  return (res.data?.countryList || []).map((item) => ({
    label: item.name,
    value: item.id,
    refCode: item.referenceCode,
  }));
};

export const getStates = async () => {
  const res = await payableApi.get(EMPLOYEE.STATES);
  return (res.data?.statesList || []).map((item) => ({
    label: item.name,
    value: String(item.id),
    refid: item.referenceID,
    refCode: item.referenceCode,
  }));
};

export const fileUpload = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.FILE_UPLOAD, payload);
  return res.data;
};

export const getFiles = async (empId) => {
  const res = await coreApi.post(EMPLOYEE.FILES_LIST, { ReferenceID: empId });
  return res.data;
};

export const deleteFile = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.FILE_DELETE, payload);
  return res.data;
};

export const downloadFile = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.FILE_DOWNLOAD, payload);
  return res.data;
};